export default __webpack_public_path__ + "static/media/Ballroll_00344.6d75446d.png";